import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { adminApi } from "@/lib/adminApi";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const loc = useLocation();
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await adminApi.login(password);
      toast.success("Welcome back, Lev");
      const to = loc.state?.from || "/admin";
      nav(to, { replace: true });
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink text-parchment flex items-center justify-center px-6" data-testid="admin-login-page">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm space-y-6"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-3 mb-8">
          <Lock size={18} className="text-four-yellow" />
          <h1 className="font-serif text-2xl">Admin</h1>
        </div>

        <div>
          <label className="block text-xs tracking-widest mb-2 opacity-60">PASSWORD</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            className="w-full px-4 py-3 bg-transparent border border-parchment-faint focus:border-four-yellow text-parchment outline-none transition-colors"
            data-testid="admin-login-password"
          />
        </div>

        {error && (
          <p className="text-sm text-red-300" data-testid="admin-login-error">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={submitting || !password}
          className="w-full px-5 py-3 border border-parchment-faint hover:border-four-yellow text-parchment hover:text-four-yellow text-sm tracking-widest transition-all duration-300 disabled:opacity-40"
          data-testid="admin-login-submit"
        >
          {submitting ? "…" : "ENTER"}
        </button>
      </form>
    </div>
  );
}
